import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import numberToWords from "number-to-words";
import headerLogo from "../../asset/johura_logo.png";
import signature from "../../asset/signature.png";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { useGetBothPurchaseQuery } from "../../features/api/purchaseApi";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "white",
    paddingBottom: "88pt",
  },
  header: {
    color: "white",
    // marginBottom: 5,
    textAlign: "center",
    height: "3.5cm",
  },
  imgborder: {
    borderBottom: "1px solid green",
    paddingBottom: "5px",
    marginBottom: "3px",
  },
  HedingTextBorder: {
    borderBottom: "1px solid red",
  },

  invTitle: {
    textAlign: "center",
    backgroundColor: "black",
    color: "white",
    padding: "4px 0px",
    fontSize: "12px",
    width: "70px",
    borderRadius: "2px",
    margin: "0 auto",
  },
  invoice: {
    padding: "10px 20px",
    fontSize: "10px",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  invLeft: {
    fontWeight: "bold",
    flexDirection: "column",
    gap: "4px",
    fontSize: "12px",
  },
  invRight: {
    fontSize: "12px",
  },
  invBottom: {
    fontSize: "11px",
    padding: "0 20 10 20",
    flexDirection: "column",
    gap: "8px",
  },
  footer: {
    color: "white",
    height: "2cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    marginTop: 20,
    textAlign: "center",
    flexDirection: "row",
    justifyContent: "center",
    fontSize: "12",
  },
  footerAddr: {
    height: "",
    color: "black",
    fontSize: "8px",
    margin: "13 auto",
    width: "100%",
    fontWeight: "thin",
  },
  footerBgc: {
    backgroundColor: "#006600",
    height: "0.8cm",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  table: {
    borderWidth: 1,
    marginHorizontal: 20,
    border: 0.5,
    fontSize: "11",
    flexFlow: 1,
  },
  tableHeaderBg: {
    backgroundColor: "#aaa",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCell: {
    borderBottomWidth: 1,
    borderRight: 1,
    borderColor: "#D0D0D0",
    textAlign: "center",
    padding: 6,
  },
  tableCellTitle: {
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
  },
  author: {
    fontSize: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "20px",
    padding: "0 20px",
  },
  authorText: {
    borderTop: "1px solid black",
    paddingTop: "1px",
  },
  thanks: {
    fontSize: "11px",
    display: "flex",
    flexDirection: "column",
    marginTop: "30px",
    padding: "0 20px",
    gap: "5px",
  },
  thanksText: { marginBottom: "80px" },
  pageNumber: {
    position: "absolute",
    bottom: 55,
    right: 20,
    fontSize: 10,
  },
});

function PurchaseView() {
  const [visible, setVisible] = useState(false);
  const [isSignature, setIsSignature] = useState(false);

  const { purId } = useParams();

  const bothSales = useGetBothPurchaseQuery(purId, {
    refetchOnMountOrArgChange: true,
  });
  const master = bothSales?.data?.master;
  const items = bothSales?.data?.data;

  // function for formated date
  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }
  const user = JSON.parse(localStorage.getItem("user"));

  const commaForAmt = (number) => {
    return number ? new Intl.NumberFormat("en-IN").format(number) : 0;
  };

  return (
    <div className="w-full max-w-[1280px] mx-auto px-6 md:px-auto  overflow-auto">
      <div className="flex gap-6 items-center justify-between my-2">
        <div className="flex items-center gap-x-2">
          <div className="flex items-center gap-x-2">
            <input
              onClick={() => setVisible(!visible)}
              type="checkbox"
              className="cursor-pointer"
            />
            <span>Pad logo</span>
          </div>
          <div className="flex items-center gap-x-2">
            <input
              onClick={() => setIsSignature(!isSignature)}
              type="checkbox"
              className="cursor-pointer"
            />
            <span>Signature</span>
          </div>
        </div>
        <Link
          to="/dashboard/purchase"
          className="border bg-blue-500 px-2 rounded text-white"
        >
          Back
        </Link>
      </div>
      <PDFViewer style={{ width: "100%", height: "100vh" }}>
        <Document>
          <Page size="A4" style={styles.page}>
            {/* Header */}
            <View style={styles.header} fixed>
              {visible && (
                <View>
                  <View style={styles.imgborder}>
                    <Image src={headerLogo} />
                  </View>
                  <Text style={styles.HedingTextBorder}></Text>
                </View>
              )}
            </View>

            {/* Invoice */}
            <View style={styles.invMain}>
              <Text style={styles.invTitle}>Purchase</Text>
              <View style={styles.invoice}>
                <View style={styles.invLeft}>
                  <Text>Name: {master?.supplier}</Text>
                  <Text>Address: {master?.address}</Text>
                </View>
                <View style={styles.invRight}>
                  <Text>Purchase No: {master?.pu_no}</Text>
                  <Text style={{ margin: "2px 0px" }}>
                    Challan No: {master?.ch_no}
                  </Text>
                  <Text>Date: {formatDate(master?.ch_date)}</Text>
                </View>
              </View>
            </View>

            {/* Table */}
            <View style={styles.table}>
              {/* Table Header */}
              <View
                style={{ ...styles.tableRow, ...styles.tableHeaderBg }}
                fixed
              >
                <View style={{ ...styles.tableCell, flex: 0.5 }}>
                  <Text>Sl No.</Text>
                </View>
                <View style={{ ...styles.tableCell, flex: 2 }}>
                  <Text>Description</Text>
                </View>
                <View style={{ ...styles.tableCell, flex: 0.5 }}>
                  <Text>Qty</Text>
                </View>
                <View style={{ ...styles.tableCell, flex: 1 }}>
                  <Text>Unit Price</Text>
                </View>
                <View style={{ ...styles.tableCell, flex: 1, borderRight: 0 }}>
                  <Text>Total Price</Text>
                </View>
              </View>

              {/* Table Data */}
              {items?.map((data, index) => {
                return (
                  <View key={index} style={styles.tableRow}>
                    <View style={{ ...styles.tableCell, flex: 0.5 }}>
                      <Text>{index + 1}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        flex: 2,
                        textAlign: "left",
                      }}
                    >
                      <Text>
                        {data?.product} - {data?.model}
                      </Text>
                      {data?.serial ? (
                        <Text style={{ marginTop: "3px" }}>
                          Serial: {data?.serial}
                        </Text>
                      ) : null}
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        flex: 0.5,
                        textAlign: "center",
                      }}
                    >
                      <Text>{data?.qty}</Text>
                    </View>
                    <View style={{ ...styles.tableCell, flex: 1 }}>
                      <Text> {data?.unit_price}</Text>
                    </View>
                    <View
                      style={{
                        ...styles.tableCell,
                        flex: 1,
                        borderRight: 0,
                      }}
                    >
                      <Text>{commaForAmt(data?.total)}</Text>
                    </View>
                  </View>
                );
              })}
              <View style={styles.tableRow}>
                <View
                  style={{
                    ...styles.tableCell,
                    borderRight: 0,
                    flex: 1,
                    borderBottom: 0.3,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    // paddingRight:'20px'
                  }}
                >
                  <Text style={{ textTransform: "capitalize" }}>
                    ( In word:{" "}
                    {typeof master?.sub_total !== "number" ||
                    !isFinite(master?.sub_total)
                      ? "error"
                      : numberToWords.toWords(master?.sub_total)}{" "}
                    Taka Only)
                  </Text>
                  <Text style={{ fontSize: "11px" }}>
                    Total: {commaForAmt(master?.sub_total)}
                  </Text>
                </View>
              </View>
            </View>

            <View style={styles.thanks}>
              <Text style={styles.thanksText}>Thanks for</Text>
              {isSignature && (
                <View>
                  <View
                    style={{
                      width: "100px",
                      marginTop: "-80px",
                      marginLeft: "-12px",
                    }}
                  >
                    <Image src={signature} />
                  </View>
                </View>
              )}
              <Text>Engr. Md Jahangir Alam</Text>
              <Text>Managing Director</Text>
              {/* <Text>JOHURA ENDOMED SOLUTION</Text> */}
            </View>
            <View style={styles.author}>
              <Text>Prepared By: {user?.name}</Text>
            </View>

            {/* Page Number */}
            <View style={styles.pageNumber} fixed>
              <Text
                render={({ pageNumber, totalPages }) =>
                  `page ${pageNumber} of ${totalPages}`
                }
              />
            </View>

            {/* Footer */}
            <View style={styles.footer} fixed>
              {visible && (
                <View style={styles.footerAddr}>
                  <Text>
                    15/A Zigatola, Hafizullah Green Tower, Flat # C1, Dhanmondi,
                    Dhaka - 1209
                  </Text>
                  <Text>
                    Cell: 01711-071102, 01977-071102, 01778-874364, E-mail:
                    jahangirjohura@gmail.com / Web: www.johurabd.com
                  </Text>
                </View>
              )}
              {visible && <Text style={styles.footerBgc}></Text>}
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
}

export default PurchaseView;
